"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREV_NAVIGATION_PAGE = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var image_1 = __importDefault(require("next/image"));
var react_1 = __importStar(require("react"));
var BalanceDropdown_1 = __importDefault(require("./BalanceDropdown"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
exports.PREV_NAVIGATION_PAGE = 'prev_navigation_page';
var Balance = function () {
    var _a;
    var _b = (0, swr_hooks_1.useBalance)(), data = _b.data, isLoading = _b.isLoading, isValidating = _b.isValidating;
    var getDataFromCache = (0, swr_hooks_1.useCache)().getDataFromCache;
    var prevPage = getDataFromCache(exports.PREV_NAVIGATION_PAGE);
    var isPrevGamePage = /game\/\w*/.test(prevPage);
    var _c = (0, react_1.useState)(false), isBalanceOpen = _c[0], setIsBalanceOpen = _c[1];
    var handleClickBalanceInfo = (0, react_1.useCallback)(function () { return setIsBalanceOpen(!isBalanceOpen); }, [setIsBalanceOpen, isBalanceOpen]);
    var closeBalanceDropdown = (0, react_1.useCallback)(function () { return setIsBalanceOpen(false); }, [setIsBalanceOpen]);
    var balanceRef = (0, react_1.useRef)(null);
    (0, apps_shared_1.useClickOutside)(closeBalanceDropdown, balanceRef);
    if (!data || isLoading || (isPrevGamePage && isValidating))
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(isBalanceOpen ? styles_module_scss_1.default.balanceOpened : ''), ref: balanceRef },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inner, onClick: handleClickBalanceInfo },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, "".concat((0, apps_shared_1.getCurrencySymbol)(data === null || data === void 0 ? void 0 : data.currency), " ").concat((_a = Number(data === null || data === void 0 ? void 0 : data.totalAmount)) === null || _a === void 0 ? void 0 : _a.toFixed(2))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.icon },
                react_1.default.createElement(image_1.default, { alt: "arrow", src: isBalanceOpen
                        ? '/img/icons/dropdown-arrow-round-gold.svg'
                        : '/img/icons/dropdown-arrow-round.svg', width: 12, height: 12 }))),
        isBalanceOpen && (react_1.default.createElement(react_1.Suspense, { fallback: false },
            react_1.default.createElement(BalanceDropdown_1.default, null)))));
};
exports.default = Balance;
